module.exports = __webpack_public_path__ + "static/media/add staff.f94320d7.svg";